import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Button,
  Box,
  Paper,
} from '@mui/material';

const Welcome = () => {
  const navigate = useNavigate();

  const handleStart = () => {
    navigate('/interview');
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          py: 4,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
          }}
        >
          <Typography variant="h4" component="h1" gutterBottom align="center">
            Lemon Car Quiz 
          </Typography>
          <Typography variant="body1" align="center" sx={{ mb: 3 }}>
            <b>We only need 2 minutes</b> and we'll determine if we can help!
          </Typography>
          <Button
            variant="contained"
            size="large"
            onClick={handleStart}
            sx={{ minWidth: 200 }}
          >
            Start 
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default Welcome; 
